import { Analytics } from "./types.ts";
import { createContext } from "react";
import { LoggerAnalytics } from "./LoggerAnalytics.tsx";

const AnalyticsContext = createContext<Analytics>(new LoggerAnalytics());

export default AnalyticsContext;
